import React from 'react';
import { Grid, FormControlLabel, RadioGroup, Radio, TextField } from '@material-ui/core';
import styles from '../analytics.module.css';
import commonStyles from '../../common/common.module.css';
import { CustomerWaitQuery } from '../../../models/Analytics';

interface QueryProps {
  query: CustomerWaitQuery;
  queryResult: number;
  handleChangeQuery: (type: string, comp: string, value: number) => void;
};

const Query = (props: QueryProps) => {

  return (
    <div className={`${styles.customerGridItems}`}>
      <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div className={`${styles.wtOuterGridItems} ${styles.noOfOrders}`}>
            <h5 className={`${styles.heading} ${commonStyles.mb0} ${styles.orderHeading}`}> Numbers of orders where: </h5>
            <RadioGroup
              row
              aria-label=""
              name=""
              className={`${styles.customerRadioGroup}`}>
              <FormControlLabel
                control={
                  <Radio
                    name="awbs"
                    color="primary"
                    size="small"
                    value='AWBS'
                    checked={'AWBS' === props.query.type}
                    onClick={() => {
                      props.handleChangeQuery('AWBS', props.query.cmp, props.query.value)
                    }}
                  />
                }
                label="awbs"
                className={styles.carrierRadio}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="pcs"
                    color="primary"
                    size="small"
                    value='PCS'
                    checked={'PCS' === props.query.type}
                    onClick={() => {
                      props.handleChangeQuery('PCS', props.query.cmp, props.query.value)
                    }}
                  />
                }
                label="pcs"
                className={styles.carrierRadio}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="wgt"
                    color="primary"
                    size="small"
                    value='WGT'
                    checked={'WGT' === props.query.type}
                    onClick={() => {
                      props.handleChangeQuery('WGT', props.query.cmp, props.query.value)
                    }}
                  />
                }
                label="wgt"
                className={styles.carrierRadio}
              />
            </RadioGroup>
            <RadioGroup
              row
              aria-label=""
              name=""
              className={`${styles.customerRadioGroup} ${commonStyles.ml3}`}>
              <FormControlLabel
                control={
                  <Radio
                    name="less"
                    color="primary"
                    size="small"
                    value='LT'
                    checked={'LT' === props.query.cmp}
                    onClick={() => {
                      props.handleChangeQuery(props.query.type, 'LT', props.query.value)
                    }}
                  />
                }
                label="less than"
                className={styles.carrierRadio}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="greater"
                    color="primary"
                    size="small"
                    value='GT'
                    checked={'GT' === props.query.cmp}
                    onClick={() => {
                      props.handleChangeQuery(props.query.type, 'GT', props.query.value)
                    }}
                  />
                }
                label="greater than"
                className={styles.carrierRadio}
              />
            </RadioGroup>
            <div>
              <TextField
                id="forwarder"
                label=""
                name="forwarder"
                variant="outlined"
                value={props.query.value}
                onChange={(e) => {
                  props.handleChangeQuery(props.query.type, props.query.cmp, parseInt(e.currentTarget.value) || 0)
                }}
                className={styles.ip40}
              />
              <span className={styles.equalSign}>=</span>
            </div>
            <div className={commonStyles.mlauto}>
              <span className={styles.total}>{props.queryResult}</span>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Query;